export { StatusBar } from 'native-base';
